import { call, put, select, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { authSelectors } from '@rosetta/react-auth';
import { exportUserReport, downloadUserReport, getUserReportStatus } from '../services/export-api';
import { GENERATE_EXPORT, DOWNLOAD_REPORT, exportActions } from '../reducer/export-reducer';
import moment from 'moment';
import { logBrazeEvent } from '../../../helpers/engagementHelper';

function* generateDashboardExport(action) {
  const userId = yield select(authSelectors.userId);
  const authToken = yield select(authSelectors.authToken);
  const start = moment(action.payload.startDate).format('YYYY-MM-DD');
  const end = moment(action.payload.endDate).format('YYYY-MM-DD');

  let exportedReportData = null;
  try {
    exportedReportData = yield call(exportUserReport, userId, start, end, authToken);

    if (exportedReportData) {
      // polling setup. Currently processing the report, so check the reportStatus endpoint for detail on how the export is going
      let processingReport = true;
      let pollTimer = 0;

      while (processingReport) {
        /*
          checking to see what the report status and polling if the report is pending.
          status options are COMPLETE/FAILED/PENDING
          if a report is PENDING for more than 600 tries, then throw an error.
        */
        const reportJobStatus = yield call(getUserReportStatus, exportedReportData.id, authToken);
        if (reportJobStatus) {
          if (reportJobStatus.status === 'COMPLETE') {
            processingReport = false;
            // Notify engagement service that report has been successfully downloaded.
            logBrazeEvent('DownloadedReport', {});
            yield put(exportActions.successGeneratingExport(reportJobStatus.id));
          } else if (reportJobStatus.status === 'FAILED') {
            processingReport = false;
            yield put(exportActions.errorGeneratingExport('report failed'));
          } else if (pollTimer > 600) {
            processingReport = false;
            yield put(exportActions.errorGeneratingExport('report timed out'));
            // todo: do we need to remove the report?
          } else {
            // report is still proccessing
            processingReport = true;
            pollTimer++;
            yield delay(1000);
          }
        }
      }
    }
  } catch (error) {
    yield put(exportActions.errorGeneratingExport(error));
  }
}

function* downloadReport(action) {
  const authToken = yield select(authSelectors.authToken);
  const reportId = action.payload.reportId;
  const format = action.payload.format;

  try {
    yield call(downloadUserReport, reportId, format, authToken);
  } catch (error) {
    console.log(error);
  }
}

export function* exportSagas() {
  yield takeLatest(GENERATE_EXPORT, generateDashboardExport);
  yield takeLatest(DOWNLOAD_REPORT, downloadReport);
}



// WEBPACK FOOTER //
// ./src/modules/launchpad/sagas/export-sagas.js